/*
 * 统一管理从服务端获取的数据，方便后期维护
 * 通过export  暴露封装的获取数据方法
 */
import Axios from "axios";
import netWork from '../api/netWork'


const industryAnalyze = process.env.VUE_APP_SERVER_URL2
const server = process.env.VUE_APP_FILE_SERVER_URL


//本小组接口（完成）
//上传文件
export const upLoadApi = (data) => Axios.get(industryAnalyze + '/upload', data);
//下载文件
export const downLoadApi = (data) => netWork.getImageSrc(server + '/file/attachment/download', data);
//下载文件
export const downLoadFrontApi = (data) => netWork.getImageSrc(server + '/file/attachment/front/downDomain', data);
//查看文件名字
export const getMsgByIdApi = (data) => netWork.get(server + '/file/attachment/getMsgById', data);
//获取菜单栏
export const dynamicRoutingApi = () => netWork.get(`${process.env.VUE_APP_USER_CENTER_SERVER_URL}/ucenter/menu/listModelMenuTree?modelId=${process.env.VUE_APP_MODEL_ID}`)
//获取moduleId
export const modelID = () => { return process.env.VUE_APP_MODEL_ID }
// 获取上传地址
export const uploadUrl = () => { return `${server}/file/attachment/upload` }
// 获取上传地址
export const uploadUrls = (params) => {
  return Axios({
    url: `${server}/file/attachment/upload`,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    transformRequest: [], //图片上传formdata默认不用传参
    method: 'post',
    data: params,
  });
}
// 获取用户信息
export const getUserInfo = () => netWork.get(`${process.env.VUE_APP_USER_CENTER_SERVER_URL}/ucenter/user/getUserDeptDist`)

//-------------------------------------------------------------------------------------------------------------------------------------------------//

//发布会列表
export const surveyList = (data) => netWork.get(industryAnalyze + '/survey/list', data);

//发布会新增
export const surveySave = (data) => netWork.post(industryAnalyze + '/survey/save', data);

//发布会删除
export const surveyDelete = (data) => netWork.get(industryAnalyze + '/survey/delete', data);

//发布会删除主持人或发言人
export const delAttendee = (data) => netWork.get(industryAnalyze + '/survey/delAttendeeById',data)

//发布会详情
export const surveyDetail = (data) => netWork.get(industryAnalyze + '/survey/edit', data);

//发言内容编辑-列表
export const surveySpeechList = (data) => netWork.get(industryAnalyze + '/survey/speech_list', data);

//发言内容编辑-发言人列表
export const surveyAttendList = (data) => netWork.get(industryAnalyze + '/survey/attend_list', data);

//发言内容编辑-保存
export const surveySpeechSave = (data) => netWork.post(industryAnalyze + '/survey/speech_save', data);

//发言内容编辑单个-保存
export const surveySpeechSaveSingle = (data) => netWork.post(industryAnalyze + '/survey/speech_save_single', data);

//发言内容编辑-列表-整体编辑
export const surveySpeechEdit = (data) => netWork.get(industryAnalyze + '/survey/speech_edit', data);

//发言内容编辑-列表-编辑
export const surveySpeechEditById = (data) => netWork.get(industryAnalyze + '/survey/speech_editById', data);

//发言内容编辑-列表-整体删除
export const surveySpeechDel = (data) => netWork.get(industryAnalyze + '/survey/speech_del', data);

//发言内容编辑-列表-删除
export const surveySpeechDelById = (data) => netWork.get(industryAnalyze + '/survey/speech_delById', data);

// 问答内容编辑 列表
export const surveyquestionsAnswers = (data) => netWork.get(industryAnalyze + '/survey/speeches_with_question', data);

// 问答内容编辑 整体删除
export const surveyquestionsAnswersDel = (data) => netWork.get(industryAnalyze + '/survey/speech_question_del', data);

// 问答内容编辑 整体编辑
export const surveyquestionsAnswersEdit = (data) => netWork.get(industryAnalyze + '/survey/speech_question_edit', data);

// 直播图片上传 列表
export const surveyquestionsImgList = (data) => netWork.get(industryAnalyze + '/survey/img_list', data);

// 直播图片上传 新增
export const surveyquestionsImgSave = (data) => netWork.post(industryAnalyze + '/survey/img_save', data);

// 直播图片上传 删除
export const surveyquestionsImgDel = (data) => netWork.get(industryAnalyze + '/survey/img_del', data);

// 预览页面发布会 基本信息
export const issueInfoView = (data) => netWork.get(industryAnalyze + '/survey/issue_info_view', data);

// 预览页面发布会 内容发布
export const speechIssue = (data) => netWork.get(industryAnalyze + '/survey/speech_issue', data);

// 预览页面发布会 发布到门户
export const issueToWeb = (data) => netWork.get(industryAnalyze + '/survey/issue_to_web', data);

// 预览页面发布会 结束发布
export const stop = (data) => netWork.get(industryAnalyze + '/survey/stop', data);

// 门户新闻发布 基本信息
export const issueInfoViewFront = (data) => netWork.get(industryAnalyze + '/front/issue_info_view', data);

// 门户新闻发布 发言内容、问答内容
export const speechListFront = (data) => netWork.get(industryAnalyze + '/front/speech_list', data);

// 门户新闻发布 发布会状态
export const taskIssueStatus = (data) => netWork.get(industryAnalyze + '/front/task_issue_status', data);
